"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import * as FC from './formcomponents';
import { mapTypeToComponent, generateTypeField } from './formengineutilities';
import { FormEngine } from './formengine';
const debug = false;
/* =====  FORM BUILDER =====
Display all the components for a Form Builder -
Element Buttons, Element Details, and the Form */
/**
 * FormBuilder — Visual editor for composing forms via JSON schema. Provides a field editor and a live preview powered by `FormEngine`.
 *
 * @param {function} [props.setFormData] - Callback that receives generated field JSON when building a new field (used by the UI to pass schema to the preview).
 */
FormBuilder.propTypes = {
    /** Callback invoked with generated form JSON */
    setFormData: PropTypes.func,
};
export function FormBuilder() {
    const [formData, setFormData] = useState({ fields: [] });
    const [fieldFormData, setFieldFormData] = useState({ fields: [] });
    function appendFormData(event) {
        // APPEND JSON FOR NEW FIELD TO EXISTING JSON CONFIG OBJECT - EXPOSED EXTERNAL
        if (debug)
            console.log("Appending form Data...");
        const props = {};
        const target = event.target;
        for (const prop in target) {
            const thisProp = target[prop];
            if (thisProp && thisProp.value && (thisProp.value !== Object(thisProp.value))) {
                props[thisProp.name] = thisProp.value;
            }
        }
        const field = {};
        field.props = props;
        field.component = mapTypeToComponent(field.props.type);
        let fields = [];
        if (Object.keys(formData).length > 0) {
            fields = JSON.parse(JSON.stringify(formData.fields));
        }
        fields[fields.length] = field;
        setFormData({ fields: fields });
        setFieldFormData({ fields: [] });
        return (field);
    }
    /* function getCircularReplacer() {
        const seen = new WeakSet();
        return (key, value) => {
            if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                    return ; // return undefined ;
                }
                seen.add(value);
            }
            return value;
        };
    } */
    return (_jsxs("div", { className: "section-container", children: [_jsxs("div", { style: { display: 'inline-block', verticalAlign: 'top' }, children: [_jsx(FormBuild, { setFormData: setFieldFormData }), _jsx("div", {}), _jsx(FormEngine, { name: "field_props", id: "field_props", onSubmitHandler: appendFormData, formData: fieldFormData })] }), _jsx("div", { style: { display: 'inline-block', verticalAlign: 'top' }, children: _jsx("pre", { style: { width: '100%' }, children: JSON.stringify(formData, null, 2) }) }), _jsxs("div", { children: [_jsx("br", {}), _jsx("br", {}), _jsx("hr", {}), _jsx("br", {}), _jsx("br", {})] }), _jsx("div", { style: { display: 'block', verticalAlign: 'top' }, children: _jsx(FormEngine, { formData: formData || {} }) })] }));
}
/*
===== FORM BUILD =====
Dynamically generate, component by component, and prop by prop,
the JSON to create a form via FormEngine
*/
FormBuild.propTypes = {
    /** Callback used to set the generated field JSON in the parent */
    setFormData: PropTypes.func.isRequired,
};
export function FormBuild(props) {
    function generateFormBuilderFieldJSON(component, type) {
        // GENERATE THE JSON TO DISPLAY A FORM TO ADD A FIELD - INTERNAL
        if (debug)
            console.log("Generating Form JSON for ", component, " Type : ", type);
        const form = { fields: [] };
        let i = 0;
        for (const prop in FC[component].propTypes) {
            const field = {};
            field.component = 'FormInput';
            const props = {};
            props.label = prop;
            props.name = prop;
            props.id = prop;
            props.type = 'text';
            if (prop === 'type') {
                props.disabled = true;
                props.value = type;
                props.list = 'inputTypes';
            }
            field.props = props;
            form.fields[i] = field;
            i++;
        }
        const addButton = {
            component: 'FormButton',
            props: {
                label: 'Add ' + component,
                type: 'submit',
                id: 'Add ' + component,
                text: 'Add ' + component
            }
        };
        form.fields[i] = addButton;
        return (form);
    }
    function handlePhaseOneSubmit(event) {
        // GENERATE THE JSON TO DISPLAY A FORM TO ADD A FIELD - EXTERNAL
        const target = event.target;
        const typeElement = target.elements.namedItem('type');
        const myType = typeElement ? typeElement.value : '';
        const myComponent = mapTypeToComponent(myType);
        const fieldJSON = generateFormBuilderFieldJSON(myComponent, myType);
        props.setFormData(fieldJSON);
        return true;
    }
    return (_jsx(_Fragment, { children: _jsx(FormEngine, { formData: generateTypeField(), onSubmitHandler: event => { handlePhaseOneSubmit(event); }, name: "build", id: "build", method: "post" }) }));
}
